/* =========================================================================
   OfficeLicense24 – Vergleichsabschnitt: zwei Nachbesserungen
   ------------------------------------------------------------------------
   TEIL 1 – ZWEI WEGE STATT EINEM KNOPF
   "Office 2024 Standard" gibt es zweimal - als eigene Lizenz fuer
   Windows und als eigene fuer Mac, zwei Produkte mit zwei Preisen. Die
   Karte zeigt beide Plattformen, hatte aber nur EINEN Knopf, und der
   fuehrte immer zur Windows-Ausgabe. Wer auf dem Mac arbeitet, landete
   auf der falschen Seite (gemeldet am 13.09.).

   Statt eines Knopfes steht dort jetzt: die Beschriftung als reiner
   Text - nicht anklickbar, weil sie fuer beide Ausgaben gilt - und
   daneben die zwei Zeichen, jedes ein eigener Link.

   TEIL 2 – DIE ERSTE HELFERFRAGE ZURUECK
   Der Abschnitt sucht die Zielspalte jeder Helferfrage selbst:
     Access -> erste Spalte, deren Programmliste Access nennt
     Mac    -> erste Spalte, deren Plattform Mac nennt
     Basis  -> erste Spalte OHNE beides
   Seit die Standard-Karte auch Mac zeigt, gibt es keine Spalte mehr
   ohne beides - die Basis-Frage faellt seither stillschweigend weg.
   Richtig waere sie als "erste Spalte ohne Access"; genau das rechnet
   der Block unten nach und haengt die Frage wieder an ihren Platz.

   WARUM ALS SKRIPT UND NICHT IM ABSCHNITT: die Karte und der Helfer
   werden in sections/bsfa-vergleich.liquid gebaut, 55 KB. Diese Datei
   laesst sich mit dem Werkzeug, mit dem das Theme gepflegt wird, nicht
   mehr am Stueck schreiben - es gibt keine teilweise Aenderung, nur
   Ersetzen des ganzen Blattes, und dafuer ist sie zu gross. Wandert der
   Abschnitt irgendwann in kleinere Blaetter, gehoert beides hier dort
   hinein und diese Datei kann weg.

   OHNE JAVASCRIPT bleibt der urspruengliche Knopf stehen und fuehrt zur
   Windows-Ausgabe, und die Basis-Frage fehlt weiter. Schlechter als
   mit, aber nicht kaputt.

   NICHTS IST FEST VERDRAHTET AUSSER DER ZUORDNUNG UNTEN:
   - die Beschriftung wird vom vorhandenen Knopf uebernommen,
   - die beiden Zeichen werden aus den Plattform-Schildchen derselben
     Karte geklont,
   - die Namen fuer Vorleseprogramme kommen aus denselben Schildchen,
   - die FORM kommt aus der Klasse `ol-vgl__cta`, die die Gruppe
     mitbekommt: gleiche Hoehe, Rundung, Kante und derselbe Abstand
     nach oben wie die Knoepfe der Nachbarkarten. Nichts davon wird
     nachgebaut, deshalb kann nichts davon auseinanderlaufen.
   - die neue Helferfrage ist eine Kopie einer vorhandenen Frage,
     ihr Satz kommt uebersetzt aus dem <meta> in ol-nacht-start.liquid,
     der Produktname aus der Karte, auf die sie zeigt.
   Damit stimmt alles in allen sechs Sprachen, ohne eine einzige neue
   Uebersetzung.
   ========================================================================= */
(function () {
  'use strict';

  /* ----------------------------------------------------------------
     TEIL 1: zwei Wege auf der Standard-Karte
     ---------------------------------------------------------------- */

  /* Windows-Produkt -> Mac-Ausgabe, beides Shopify-Handles.
     Hier stehen nur Paare, die WIRKLICH zwei getrennte Produkte sind.
     "Home & Business" gehoert NICHT dazu: das ist eine Lizenz, die
     beide Systeme abdeckt - dort ist ein Knopf richtig. */
  var MAC_AUSGABE = {
    'office-2024-standard': 'office-2024-standard-mac'
  };

  function handleAus(adresse) {
    var pfad = String(adresse || '').split('?')[0].split('#')[0].replace(/\/+$/, '');
    var teile = pfad.split('/');
    return teile[teile.length - 1];
  }

  function umbauen(karte) {
    var knopf = karte.querySelector('a.ol-vgl__cta');
    if (!knopf || karte.querySelector('.ol-vgl__wege')) return;

    var adresse = knopf.getAttribute('href') || '';
    var handle = handleAus(adresse);
    var macHandle = MAC_AUSGABE[handle];
    if (!macHandle) return;

    /* Nur wenn die Karte auch wirklich beide Plattformen zeigt. Steht
       in den Abschnittseinstellungen eines Tages wieder nur "Windows",
       soll auch wieder ein Knopf dastehen. */
    var schilder = karte.querySelectorAll('.ol-vgl__plattform');
    if (schilder.length < 2) return;

    var macSchild = null;
    var winSchild = null;
    Array.prototype.forEach.call(schilder, function (s) {
      if (/mac/i.test(s.textContent || '')) { if (!macSchild) macSchild = s; }
      else if (!winSchild) { winSchild = s; }
    });
    if (!macSchild || !winSchild) return;

    /* Nur der letzte Pfadteil wird getauscht - Sprachpraefix (/it, /fr)
       und alles davor bleiben unangetastet. */
    var macAdresse = adresse.replace(new RegExp(handle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(?=$|[?#])'), macHandle);
    if (macAdresse === adresse) return;

    var wort = (knopf.textContent || '').trim();

    var gruppe = document.createElement('div');
    /* ol-vgl__cta: die Form der Nachbarknoepfe, geerbt statt nachgebaut.
       ol-vgl__wege: nur die Innereien, siehe ol-vergleich.css. */
    gruppe.className = 'ol-vgl__cta ol-vgl__wege';
    /* data-echt: der Kartenschalter des Abschnitts laesst alles in
       Ruhe, was so markiert ist. Ohne das wuerde ein Klick auf ein
       Zeichen nur die Tabellenspalte umschalten. */
    gruppe.setAttribute('data-echt', '');

    var beschriftung = document.createElement('span');
    beschriftung.className = 'ol-vgl__wegwort';
    beschriftung.textContent = wort;
    gruppe.appendChild(beschriftung);

    var reihe = document.createElement('span');
    reihe.className = 'ol-vgl__wegknoepfe';

    [[adresse, winSchild], [macAdresse, macSchild]].forEach(function (paar) {
      var ziel = paar[0];
      var schild = paar[1];
      var name = (schild.textContent || '').trim();

      var link = document.createElement('a');
      link.className = 'ol-vgl__weg';
      link.href = ziel;
      link.setAttribute('data-echt', '');
      link.setAttribute('aria-label', wort + ' – ' + name);
      link.setAttribute('title', name);

      var zeichen = schild.querySelector('svg');
      if (zeichen) link.appendChild(zeichen.cloneNode(true));
      reihe.appendChild(link);
    });

    gruppe.appendChild(reihe);
    knopf.parentNode.replaceChild(gruppe, knopf);
  }

  /* ----------------------------------------------------------------
     TEIL 2: die Basis-Frage wieder einhaengen
     ---------------------------------------------------------------- */

  /* Erste Spalte, die in der Access-Zeile ein Minus traegt. "Access"
     heisst in allen sechs Sprachen Access - es ist ein Produktname,
     da ist nichts zu uebersetzen und nichts zu raten. */
  function basisSpalte(abschnitt) {
    var zeilen = abschnitt.querySelectorAll('.ol-vgl__zeile');
    for (var i = 0; i < zeilen.length; i++) {
      var name = zeilen[i].querySelector('.ol-vgl__mtext');
      if (!name || !/access/i.test(name.textContent || '')) continue;
      var zellen = zeilen[i].querySelectorAll('.ol-vgl__zelle[data-spalte]');
      for (var k = 0; k < zellen.length; k++) {
        if (zellen[k].querySelector('.ol-vgl__nein')) {
          return zellen[k].getAttribute('data-spalte');
        }
      }
      return null;
    }
    return null;
  }

  function helferErgaenzen(abschnitt) {
    var liste = abschnitt.querySelector('.ol-vgl__helferliste');
    if (!liste) return;

    var meta = document.querySelector('meta[name="ol-vgl-basis"]');
    var satz = meta ? (meta.getAttribute('content') || '').trim() : '';
    if (!satz || satz.indexOf('translation missing') === 0) return;

    /* Baut der Abschnitt die Frage selbst wieder, steht ihr Satz
       bereits da - dann haelt sich das Skript heraus. Derselbe Satz
       ist das sicherste Erkennungszeichen, das es hier gibt. */
    var faelle = liste.querySelectorAll('.ol-vgl__helferfall');
    for (var i = 0; i < faelle.length; i++) {
      if ((faelle[i].textContent || '').trim() === satz) return;
    }

    var vorlage = liste.querySelector('li');
    if (!vorlage) return;

    var spalte = basisSpalte(abschnitt);
    if (!spalte) return;

    var karte = abschnitt.querySelector('.ol-vgl__karte[data-spalte="' + spalte + '"]');
    if (!karte) return;
    var kartenname = karte.querySelector('.ol-vgl__name');
    if (!kartenname) return;

    var zeile = vorlage.cloneNode(true);
    var knopf = zeile.querySelector('.ol-vgl__helferknopf');
    var fall = zeile.querySelector('.ol-vgl__helferfall');
    var zielname = zeile.querySelector('.ol-vgl__helferziel span');
    if (!knopf || !fall || !zielname) return;

    knopf.setAttribute('data-ziel', spalte);
    knopf.setAttribute('aria-pressed', 'false');
    knopf.classList.remove('ist-aktiv');
    fall.textContent = satz;
    /* "Microsoft " faellt weg wie bei den anderen Fragen auch. */
    zielname.textContent = (kartenname.textContent || '').trim().replace(/^Microsoft\s+/i, '');

    function spiegeln() {
      var an = karte.classList.contains('ist-gewaehlt');
      if (an) { knopf.classList.add('ist-aktiv'); } else { knopf.classList.remove('ist-aktiv'); }
      knopf.setAttribute('aria-pressed', an ? 'true' : 'false');
    }

    /* Der Abschnitt hat seine eigenen Knoepfe beim Laden eingesammelt -
       dieser hier war da noch nicht dabei. Deshalb klickt er einfach
       die Karte an; alles Weitere macht der Abschnitt wie gehabt. */
    knopf.addEventListener('click', function () {
      var vorher = karte.classList.contains('ist-gewaehlt');
      karte.click();
      spiegeln();
      if (vorher || !karte.scrollIntoView) return;
      var eng = window.matchMedia && window.matchMedia('(max-width: 989px)').matches;
      if (!eng) return;
      var sanft = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try {
        karte.scrollIntoView({ behavior: sanft ? 'auto' : 'smooth', block: 'center' });
      } catch (fehler) {
        karte.scrollIntoView();
      }
    });

    /* Wird stattdessen eine Karte oder eine andere Frage angeklickt,
       zieht dieser Knopf nach. Der Abschnitt kennt ihn nicht. */
    abschnitt.addEventListener('click', function () {
      window.setTimeout(spiegeln, 0);
    });

    liste.insertBefore(zeile, liste.firstElementChild);
    spiegeln();
  }

  function los() {
    var karten = document.querySelectorAll('.ol-vgl__karte');
    Array.prototype.forEach.call(karten, umbauen);

    var abschnitte = document.querySelectorAll('.ol-vgl');
    Array.prototype.forEach.call(abschnitte, helferErgaenzen);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', los);
  } else {
    los();
  }
})();
